<template>
  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-card-title class="secondary white--text">
        Edit Commitment Entry
        <v-spacer />
        <v-btn icon @click="showDialog = false">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="6">
            <InputField
              label="Committed *"
              type="number"
              v-model="form.committed"
              :error-messages="formErrors.committed"
              @input="delete formErrors.committed"
            />
          </v-col>
          <v-col cols="6">
            <InputField
              label="Allocated"
              type="number"
              v-model="form.allocated"
              :error-messages="formErrors.allocated"
              @input="delete formErrors.allocated; validateAllocated()"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end pa-4">
        <v-btn depressed @click="showDialog = false">Cancel</v-btn>
        <v-btn color="primary" depressed @click="submitForm">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
export default {
  components: { InputField },
  props: {
    value: Boolean,
    entryId: { type: Number, default: null },
  },
  data() {
    return {
      form: { committed: null, allocated: null },
      formErrors: {},
    };
  },
  computed: {
    showDialog: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
  },
  watch: {
    value(val) {
      if (val && this.entryId) this.loadEntry();
    },
  },
  methods: {
    loadEntry() {
      this.$api.subHireCommitment
        .getSubHireCommitmentEntryObject(this.entryId)
        .then((res) => {
          this.form = { committed: res.data.committed, allocated: res.data.allocated };
        })
        .catch(console.error);
    },
    validateAllocated() {
      const committed = parseFloat(this.form.committed);
      const allocated = parseFloat(this.form.allocated);
      if (!isNaN(committed) && !isNaN(allocated) && allocated > committed) {
        this.formErrors.allocated = "Allocated cannot be greater than committed.";
      } else {
        delete this.formErrors.allocated;
      }
    },
    submitForm() {
      this.validateAllocated();
      if (this.formErrors.allocated) return;
      this.$api.subHireCommitment
        .updateSubHireCommitmentEntry({ id: this.entryId, data: this.form })
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Entry updated successfully",
            color: "success",
          });
          this.$emit("refreshList");
          this.showDialog = false;
        })
        .catch((err) => {
          this.formErrors = err.data || {};
        });
    },
  },
};
</script>
